import IAmount from "@/module/main/dto/IAmount";
import IMerchantOrder from "@/module/main/dto/IMerchantOrder";
import IOrderItem from "@/module/main/dto/financing-v3/IOrderItem";

export default class MerchantOrder implements IMerchantOrder
{
    public readonly totalPrice: IAmount | undefined;
    public readonly name: string;
    public readonly url?: string;
    public readonly businessIdentificationNumber?: string;
    public readonly number?: string;
    public readonly reservationDate?: string;
    public readonly items?: IOrderItem[];

    constructor(props: IMerchantOrder)
    {
        this.totalPrice = props.totalPrice;
        this.name = props.name;
        this.url = props.url;
        this.businessIdentificationNumber = props.businessIdentificationNumber;
        this.number = props.number;
        this.reservationDate = props.reservationDate;
        this.items = props.items;
    }
}
